import PropTypes from 'prop-types';
import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';
import {isEmpty} from 'front-onceforall-core/dist/utils/strings';
import {I18n, Translate} from 'react-redux-i18n';
import {DocumentDossierChips, Icon, TextCheckbox} from 'front-onceforall-core';
import {Tooltip} from '@material-ui/core';
import {isRejected} from '../../../utils/document';
import authenticationService from '../../../services/authentication/AuthenticationService';
import config from '../../../../config';
import DocumentState from '../../document/DocumentState';
import DownloadButtons from './downloadButtons';

function ListItemView(props) {
  const {document} = props;
  const isBackOffice = authenticationService.roles().isBackOffice();
  const hideValidityPeriod = !document.validityStart || !document.validityEnd || document.state === DOCUMENT_STATE.AWAITING_VALIDATION || isRejected(document);
  const hasCertifyingThirdParty = !isEmpty(document.certifyingThirdParty);
  const validityPeriod = hideValidityPeriod ? '-' :
    <Translate
      value="document.validityPeriod"
      startDate={I18n.l(document.validityStart, {dateFormat: 'datetime.shortDate'})}
      endDate={I18n.l(document.validityEnd, {dateFormat: 'datetime.shortDate'})}
    />;

  function handleClickDocument() {
    if (!isBackOffice) {
      return;
    }

    window.location.href = `${config.backOfficeUrl}/documents/${props.document.uid}`;
  }

  return (
    <tr>
      {props.documentsSelected &&
        <td>
          <TextCheckbox
            checked={props.documentsSelected[document.uid]}
            onChange={() => props.onCheckEvent(document.uid)}
          />
        </td>
      }
      <td>
        <div
          className={`two-lines${isBackOffice ? ' clickable bo' : ''}`}
          onClick={handleClickDocument}
        >
          <div className="flex-container">
            {document.collectionMandateEnabled &&
              <Tooltip title={<Translate value={`document.collectionMandateEnabled.${document.type.country}`}/>}>
                <div className="d-flex align-items-center">
                  <Icon
                    icon="drawer"
                    size={14}
                  />
                </div>
              </Tooltip>
            }
            <span data-id="name">{document.type.name}</span>
          </div>
          {(hasCertifyingThirdParty || !isEmpty(document.additionalDesignation)) &&
            <div>
              {hasCertifyingThirdParty &&
                <span
                  data-id="certifyingThirdParty"
                  className="information"
                >{document.certifyingThirdParty}</span>
              }
              {!isEmpty(document.additionalDesignation) &&
                <span
                  data-id="additionalDesignation"
                  className={`information${hasCertifyingThirdParty ? ' separator' : ''}`}
                >
                  {document.additionalDesignation}
                </span>
              }
            </div>
          }
        </div>
      </td>
      <td>
        <DocumentState
          data-id="state"
          state={document.state}
          readOnly
        />
      </td>
      {props.showRemindedDocumentsState &&
        <td>
          <DocumentState
            data-id="remindedState"
            state={document.remindedState}
            readOnly
          />
        </td>
      }
      <td>
        <DocumentDossierChips
          dossiers={document.dossiers}
        />
      </td>
      <td>
        <div
          className="no-wrap"
          data-id="validity-period"
        >
          {validityPeriod}
        </div>
      </td>
      {props.allowDownload &&
        <td>
          <div className="inline-container flex-end">
            <DownloadButtons
              document={props.document}
              onDocumentFileOpen={props.onDocumentFileOpen}
              onDocumentProofFileOpen={props.onDocumentProofFileOpen}
            />
          </div>
        </td>
      }
    </tr>
  );
}

ListItemView.propTypes = {
  document: PropTypes.object.isRequired,
  showRemindedDocumentsState: PropTypes.bool,
  allowDownload: PropTypes.bool,
  onDocumentFileOpen: PropTypes.func,
  onDocumentProofFileOpen: PropTypes.func,
  onCheckEvent: PropTypes.func,
  documentsSelected: PropTypes.array
};

export default ListItemView;
